import { Component, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { Subscription } from 'rxjs';

import { KipService } from './modules/shared/services/kip-service/kip.service';
import { LanguageService } from './modules/shared/services/language-service/language.service';
import { RedirectLoaderService } from './modules/shared/services/redirect-loader.service';
import { TokenService } from './modules/shared/services/token-service/token.service';
import { WindowRefService } from './modules/shared/services/window-ref-service/window-ref.service';

// declare gtag which is collected from gloabal window space(script in index.html) as a function to set and sent the events
// eslint-disable-next-line no-empty-pattern
declare let gtag: (a, b, {}) => void;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnDestroy {
  private router$: Subscription;
  constructor(
    public router: Router,
    public translate: TranslateService,
    private tokenService: TokenService,
    private kipService: KipService,
    private windowRefService: WindowRefService,
    private languageService: LanguageService,
    private cookieService: CookieService,
    private redirectLoaderService: RedirectLoaderService
  ) {
    this.languageService.setDefaultLanguage();
    this.setGoogleAnalytics();
    this.clearLocalStorage();
  }

  // subscribe to router events and clear local storage is browser was refreshed
  private clearLocalStorage(): void {
    if (
      window.location.pathname !== '/complete' &&
      window.location.pathname !== '/cancel'
    ) {
      this.tokenService.removeTokenFromLocalStorage();
    }
    const browserRefresh =
      this.windowRefService.nativeWindow().performance.navigation.type === 1;
    if (browserRefresh) {
      this.cookieService.delete('webpay-token');
      this.tokenService.removeTokenFromLocalStorage();
      this.cookieService.delete('kip');
      this.kipService.removeKipFromLocalStorage();
      this.redirectLoaderService.removeFromLocalStorage();
      this.router.navigateByUrl('/');
    }

    // dimioyrgei problhma stis plhrwmes kai to afairesame prosorina mexri na broyme allh lush
    // if (this.windowRefService.nativeWindow().performance.navigation.type === performance.navigation.TYPE_BACK_FORWARD) {
    //   const { kip, signature, url, language } = this.redirectLoaderService.getLocalStorageQueryParams();
    //   this.router.navigateByUrl(`redirectLoader?k=${kip}&s=${signature}&u=${url}&l=${language}`);
    // } else {
    //   // clear localstorage
    //   this.redirectLoaderService.removeFromLocalStorage();
    // }
  }

  // subscribe to router events and send page views to Google Analytics
  private setGoogleAnalytics(): void {
    this.router$ = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const win = this.windowRefService.nativeWindow() as Window & {
          gtag?: (...args: unknown[]) => void;
        };

        if (typeof win.gtag === 'function') {
          win.gtag('config', 'UA-173156561-1', {
            page_path: event.urlAfterRedirects,
          });
        }
      }
    });
  }

  ngOnDestroy(): void {
    if (this.router$) {
      this.router$.unsubscribe();
    }
  }
}
